module.exports = __webpack_public_path__ + "assets/TMove.9917e4b1c379e977459583e8b6c13a7d.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TMove.gmt
// module id = 1013
// module chunks = 0